import { Typography } from '@mui/material';

export const EmptyField = () => (
    <Typography variant='body2' className='gray'>
        —
    </Typography>
);
